// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1qp_B","tab":"ProcedureTabs_tab__2hDny"};